<div class="row wo-form" *ngIf="commonService.appointmentDetails && commonService.contactDetails">
    <div class="col-12">
        <div class="row">
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblDealersName</label><span class="text-danger"></span>
                    <div class="lbl-info"
                        *ngIf="commonService.appointmentDetails && commonService.appointmentDetails.dealerName;else load_UpdatedByElse">
                        {{commonService.appointmentDetails.dealerName}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblWoNo</label>
                    <div class="lbl-info"
                        *ngIf="commonService.appointmentDetails && commonService.appointmentDetails.workOrderNo;else load_UpdatedByElse">
                        {{commonService.appointmentDetails.workOrderNo}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblCreatedDate</label>
                    <div class="lbl-info"
                        *ngIf="commonService.appointmentCreatedDate;else load_UpdatedByElse">
                        {{commonService.appointmentCreatedDate | date:'short'}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblUpdatedBy</label><span class="text-danger"></span>
                    <div class="lbl-info"
                        *ngIf="commonService.appointmentDetails && commonService.appointmentDetails.updatedBy;else load_UpdatedByElse">
                        {{commonService.appointmentDetails.updatedBy}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-3" *ngIf="commonService.contactDetails && isShiftAppointment">
                <div class="af-form-group">
                    <button class="btn btn-primary mr-sm-2 btn-sm" (click)="ShiftAppointment(shiftAppointment)"
                        *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive"
                        [disabled]="commonService.appointmentDetails.workOrderStatusId === 0 
                  || commonService.appointmentDetails.workOrderStatusId === 3 
                  || commonService.appointmentDetails.workOrderStatusId === 4
                  || commonService.appointmentDetails.workOrderStatusId === 5 
                  || commonService.appointmentDetails.workOrderStatusId === 6
                  || commonService.appointmentDetails.workOrderStatusId === 7
                  || commonService.appointmentDetails.workOrderStatusId === 11 
                  || commonService.appointmentDetails.workOrderStatusId === 9 
                  || commonService.appointmentDetails.workOrderStatusId === 10" translate aria-label="Center Align">
                        <em class="far fa-save font16 align-top mr-2"></em>
                        lblShiftAppointment</button>
                    <span *ngIf="commonService.contactDetails.remark?.length > 0">
                        <a class="btn btn-ico" (click)="commonService.ViewRemark(viewContent)">
                            <em class="fas fa-eye fa-lg"></em>
                        </a>
                    </span>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblSourceCreation</label>
                    <div class="lbl-info">
                        <div class=" flex-wrap sourceBox">
                            {{commonService.appointmentDetails.sourceCreation}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblCreatedBy</label>
                    <div class="lbl-info"
                        *ngIf="commonService.contactDetails &&  commonService.appointmentDetails.sourceCreation==='Widget';else load_elseAdmin">
                        {{commonService.contactDetails.customerName}}
                    </div>
                    <ng-template #load_elseAdmin>
                        <div class="lbl-info"
                            *ngIf="commonService.contactDetails && commonService.contactDetails.createdBy;else load_CreatedByElse">
                            {{commonService.contactDetails.createdBy}}
                        </div>
                        <ng-template class="lbl-info" #load_CreatedByElse>
                            -
                        </ng-template>
                    </ng-template>
                </div>
            </div>

            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblAppointmentStatus</label>
                    <div class="color-box"
                        [style.background-color]="commonService.appointmentDetails.appointmentStatusColor"></div>
                    {{commonService.appointmentDetails.appointmentStatus}}
                </div>
            </div>
            <!-- <div class="col-3 af-form-group" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <b translate>lblCustomerKeyDropInfo</b>
                <label translate>lblLocker</label>
                <div class="lbl-info" *ngIf="customerKeyDropInfo">
                    {{customerKeyDropInfo.locationName}}\{{customerKeyDropInfo.lockerId}}
                </div>
            </div>
            <div class="col-3" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <label translate>lblAssignedLockerDate</label>
                <div class="lbl-info" *ngIf="customerKeyDropInfo">
                    {{customerKeyDropInfo.assignLockerDate | date:'short'}}
                </div>
            </div>
            <div class="col-3" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <label translate>lblKeyPickUpDate</label>
                <div class="lbl-info" *ngIf="customerKeyDropInfo">
                    {{customerKeyDropInfo.keyPickUpDate | date:'short'}}
                </div>
            </div> -->
            <div class="col-3" *ngIf="commonService.contactDetails">
                <div class="af-form-group">
                    <label translate>lblWoStatus</label>
                    <div class="lbl-info">
                        <div class="color-box"
                            [style.background-color]="commonService.appointmentDetails.workOrderStatusColor"></div>
                        {{commonService.appointmentDetails.workOrderStatus}}
                        <span *ngIf="commonService.IsonHoldStatus">
                            ({{commonService.contactDetails.onHoldReason}})
                            <span *ngIf="commonService.contactDetails.onHoldReasonDescription">
                                <em class="fas fa-info-circle fa-lg" placement="top"
                                    [ngbTooltip]="commonService.contactDetails.onHoldReasonDescription"></em>

                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-3 af-form-group" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <b translate>lblCustomerKeyPickUpInfo</b>
                <label translate>lblLocker</label>
                <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                    {{mechanicKeyDropInfo.locationName}}\{{mechanicKeyDropInfo.lockerId}}
                </div>
            </div>
            <div class="col-3 af-form-group" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <label translate>lblAssignedLockerDate</label>
                <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                    {{mechanicKeyDropInfo.assignLockerDate | date:'short'}}
                </div>
            </div>
            <div class="col-3 af-form-group" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <label translate>lblKeyPickUpDate</label>
                <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                    {{mechanicKeyDropInfo.keyPickUpDate | date:'short'}}
                </div>
            </div> -->
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblLastUpdatedDate</label><span class="text-danger"></span>
                    <div class="lbl-info" *ngIf="commonService.appointmentUpdatedDate;else load_UpdatedByElse">
                        {{commonService.appointmentUpdatedDate | date:'short'}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblInternalCommnets</label>
                        <a class="btn btn-ico ml-1" (click)="open(Internalcontent)">
                            <em class="fas fa-comment-alt fa-lg"></em>
                        </a>
                        <a class="btn btn-ico " (click)="ViewComment(viewComment,1)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.internalComments?.length}} </span>
                        </a>
                    </div>
                    <div *ngIf="commonService.internalComments.length > 0">
                        <div class="lbl-info">
                            {{commonService.internalComments[(commonService.internalComments.length - 1)]?.comment}}
                            <a class="btn btn-ico ml-2" (click)="copyInternalComments()">
                                <em class="fas fa-copy fa-lg"></em>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3" *ngIf="isDsoActive">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblMechanicComments</label>
                        <a class="btn btn-ico" (click)="ViewComment(viewComment,2)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.mechanicComments?.length}} </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblCustomerCommets</label>
                        <a class="btn btn-ico" (click)="ViewComment(viewComment,3)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.customerComments?.length}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-3" *ngIf="isPaymentMethodsVisible">
                <div class="af-form-group">
                    <div>
                        <label translate>lblPaymentMethod</label>
                        <div class='lbl-info'>
                            <ng-select
                                [ngClass]="{'disable':(!editAppointmentService.isEdit || isWorkOrderHistory)}"
                                placeholder="{{ 'lblSelectPaymentMethod' | translate }}"
                                [(ngModel)]="commonService.contactDetails.paymentMethodCode"
                                [disabled]="!isPaymentMethodsEditable">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblPaymentMethod</span>
                                </ng-template>
                                <ng-option *ngFor="let item of paymentMethodList" [value]="item.paymentCode">
                                    <span class="w-66px">{{item.paymentCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
            </div>
            <div class="col-3">
            </div>
            <div class="col-3">
            </div>
            <div class="col-3" *ngIf="isPaymentMethodsVisible">
                <div class="af-form-group">
                    <div>
                        <label translate>lblPaymentTerms</label>
                        <div class='lbl-info'>
                            <ng-select
                                [ngClass]="{'disable':(!editAppointmentService.isEdit || isWorkOrderHistory)}"
                                placeholder="{{ 'lblSelectPaymentTerms' | translate }}"
                                [(ngModel)]="commonService.contactDetails.paymentTermsCode"
                                [disabled]="!isPaymentMethodsEditable">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblPaymentTerms</span>
                                </ng-template>

                                <ng-option *ngFor="let item of paymentTermsList" [value]="item.paymentTermCode">
                                    <span class="w-66px">{{item.paymentTermCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentTermDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Comment & Shift Appointment Models -->
            <ng-template #shiftAppointment let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblShiftAppointment</h4>
                    <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card pad15">
                        <div class="col-12">
                            <label translate>lblDealersName</label><span class="text-danger"> *</span>
                            <div class="lbl-info">
                                <ng-select [ngModelOptions]="{standalone: true}"
                                    placeholder="{{ 'lblSelectDealer' | translate }}" (change)="onDealerChange($event)"
                                    appendTo="body">
                                    <ng-option *ngFor="let dealer of commonService.dealers" [value]="dealer.dealerId">
                                        {{dealer.name}}
                                    </ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <div class="af-form-group">
                                <label translate>lblRemark</label>
                                <textarea class="form-control" name="textDescription" [(ngModel)]="remark"
                                    maxlength="1000">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="d-flex flex-sm-row flex-column justify-content-end">
                        <button type="submit" class="btn btn-primary mr-sm-2" translate
                            (click)="ChangeDealerOfAppoitment()" aria-label="Center Align">lblOk</button>
                        <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary"
                            aria-label="Center Align" translate>lblCancel</button>
                    </div>
                </div>
            </ng-template>
            <ng-template #viewContent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblRemark
                    </h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                            aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body table-responsive remark">
                    <div style="margin: 15px;">{{commonService.contactDetails?.remark}}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
                        translate>lblCancel</button>
                </div>
            </ng-template>
            <ng-template #viewComment let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===1" translate>lblInternalCommnets
                    </h4>
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===2" translate>lblMechanicComments
                    </h4>
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===3" translate>lblCustomerCommets
                    </h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                            aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body table-responsive">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th translate>lblComment</th>
                                <th translate *ngIf="commentType != 3;">lblUser</th>
                                <th translate>lblCreatedDate</th>
                                <th translate *ngIf="commentType != 3;">lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="commentType===1">
                                <ng-container *ngIf="commonService.internalComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.internalComments">
                                        <td>
                                            {{data.comment ? data.comment : ''}}
                                        </td>
                                        <td>
                                            {{data.user ? data.user : ''}}
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                        <ng-container>
                                            <td>
                                                <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                                                    (click)="EditComment(editContent,data)">
                                                    <em class="fas fa-pencil-alt fa-lg"></em>
                                                </a>
                                                <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                                                    (click)="DeleteComment(data)">
                                                    <em class="far fa-trash-alt fa-lg"></em>
                                                </a>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="commentType===2">
                                <ng-container *ngIf="commonService.mechanicComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.mechanicComments">
                                        <td class="text-truncate width" tooltipClass="tooltop-maxw" placement="right"
                                            ngbTooltip="{{data.comment}}">
                                            {{data.comment ? data.comment : ''}}
                                        </td>
                                        <td>
                                            {{data.user ? data.user : ''}}
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="commentType===3">
                                <ng-container *ngIf="commonService.customerComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.customerComments">
                                        <td>
                                            {{data.comment ? data.comment : ''}}
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else_comments>
                                <tr>
                                    <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate>lblCancel</button>
                </div>
            </ng-template>
            <ng-template #Internalcontent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblInternalCommnets</h4>
                    <button type="button" class="close" #closeModal id="modelButton" aria-label="Close"
                        (click)="modal.dismiss('Cross click')"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="mb-3">
                            <div class="af-form-group">
                                <label translate>lblComment</label>
                                <textarea name="" class="form-control" rows="5" [(ngModel)]="commonService.internalCommentData"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-lg"
                        [disabled]="!editAppointmentService.isEdit || commonService.internalCommentData == null"
                        (click)="AddInternalComment()" translate>lblSave</button>
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate>lblCancel</button>
                </div>
            </ng-template>
            <ng-template #editContent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblEditInternalCommnets
                    </h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                            aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body table-responsive">
                    <form [formGroup]="editcommentform">
                        <label class="text" for="comment" translate>
                            lblComment <strong class="mlt6 required"> * </strong>
                        </label>
                        <div class="lbl-info">
                            <input formControlName="comment" class="form-control mb-2" [(ngModel)]="editCommentText">
                        </div>
                        <div *ngIf="!editcommentform.controls.comment?.valid && (editcommentform.controls.comment?.dirty || editcommentform.controls.comment?.touched)"
                            class="help-block text-danger">
                            <span translate>lblCommentRequired</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-lg" (click)="EditCommentDetails()"
                        [disabled]="!editcommentform.valid" translate><em
                            class="far fa-save font16 align-top mr-2"></em>lblSave</button>
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
                </div>
            </ng-template>
        </div>
    </div>
</div>